import React, { Component } from 'react';
import Text from '../../../../basicElement/Text';
import TableC from '../../../../basicElement/TableC';
import EditableCell from '../../../../basicElement/EditableCell';
import format from '../../../../shared/format';

class ServiceCycle extends Component {
    state = {
        data: [
            {paymentPlan: '第1笔付款', paymentNode: '合同签署后10个工作日内', paymentPercentage: '30', serviceFee: '918454.27'},
            {paymentPlan: '第2笔付款及之后', paymentNode: '', paymentPercentage: '', serviceFee: ''},
            {paymentNode: '合计'},
        ]
    }

    getColumns = () => {
        const { editable, names } = this.props;
        const { data } = this.state;
        const len = data.length;
        const columns = [{
            title: names.paymentPlan,
            dataIndex: 'paymentPlan',
            key: 'paymentPlan',
            width: 160,
        }, {
            title: <Text asterisk={editable}>{names.paymentNode}</Text>,
            dataIndex: 'paymentNode',
            key: 'paymentNode',
            width: 300,
            render: (text, record, index) => {
                if (index === 0) {
                    return (
                        <EditableCell
                            type="Input"
                            editable={editable}
                            value={text}
                            placeholder={names.inputPlaceholder}
                            onChange={e => this.handleInputChange(e, index, 'paymentNode')}
                        />
                    );
                } else if (index === 1) {
                    return (
                        <div>
                            {names.every}
                            {
                                <EditableCell
                                    type="Number"
                                    editable={editable}
                                    value={text}
                                    style={{margin: '0 4px'}}
                                    placeholder={names.inputPlaceholder}
                                    config={{max: 100}}
                                    onChange={value => this.handleNumberChange(value, index, 'paymentNode')}
                                />
                            }
                            {names.monthPay}
                        </div>
                    );
                } else {
                    return <strong>{text}</strong>;
                }
            }
        }, {
            title: <Text asterisk={editable}>{names.paymentPercentage}</Text>,
            dataIndex: 'paymentPercentage',
            key: 'paymentPercentage',
            width: 200,
            render: (text, record, index) => {
                if (index === 0) {
                    return (
                        <div>
                            <EditableCell
                                type="Number"
                                editable={editable}
                                value={text}
                                style={{ width: '90%' }}
                                placeholder={names.inputPlaceholder}
                                config={{max: 100, precision: 2}}
                                onChange={value => this.handleNumberChange(value, index, 'paymentPercentage')}
                            />
                            &nbsp;%
                        </div>
                    );
                } else if (index === 1) {
                    return text ? <span>{text} %</span> : '';
                } else {
                    return text ? <strong>{text} %</strong> : '';
                }
            }
        }, {
            title: names.serviceFee,
            dataIndex: 'serviceFee',
            key: 'serviceFee',
            width: 180,
            render: (text, record, index) => {
                if (index === len - 1) {
                    let total = 0;
                    data.forEach((item, index) => {
                        if (index < len - 1) {
                            total += (item.cost || 0) * 1;
                        }
                    });
                    return format('money', total);
                } else {
                    return <strong>{format('money', text)}</strong>;
                }
            }
        }, {
            title: names.comments,
            dataIndex: 'comments',
            key: 'comments',
            render: (text, record, index) => {
                return (
                    <EditableCell
                        type="Input"
                        editable={editable}
                        value={text}
                        placeholder={names.inputPlaceholder}
                        onChange={e => this.handleInputChange(e, index, 'comments')}
                    />
                );
            }
        }];
        return columns;
    }

    handleInputChange = (e, index, key) => {
        const { data } = this.state;
        data[index][key] = e.target.value;
        this.setState({ data });
    }

    handleNumberChange = (value, index, key) => {
        const { data } = this.state;
        data[index][key] = value;
        this.setState({ data });
    }

    render() {
        const { typeName } = this.props;
        const { data } = this.state;
        return (
            <div>
                <div style={{ margin: '10px 0', padding: '0 10px', width: '60%', lineHeight: '32px', background: '#f1f1f1' }}>
                    付款金额总计：
                    <span style={{marginRight: 4, color: '#F00', fontWeight: 'bold'}}>10,205,047.48</span>
                    元
                    <span className="ant-divider" />
                    付款计划类型：
                    { typeName }
                </div>
                <TableC
                    data={data}
                    columns={this.getColumns()}
                    className="quotation_serviceCycle"
                />
            </div>
        );
    }
}

export default ServiceCycle;


// WEBPACK FOOTER //
// ./src/components/quotation/Production/Payment/Table/ServiceCycle.js